import type { ReactNode } from 'react';
import { PanelPageState } from '@/presentation/components/common/PanelPageState';

interface MetricsStateProps {
  variant: 'loading' | 'error' | 'empty';
  title?: string;
  message?: string;
  action?: ReactNode;
  onRetry?: () => void;
}

/** @deprecated Prefer PanelPageState; wrapper de compatibilidad para bloques de métricas. */
export function MetricsState({ variant, title, message, action, onRetry }: MetricsStateProps) {
  return (
    <PanelPageState
      variant={variant}
      title={title}
      message={message}
      action={action}
      onRetry={onRetry}
      layout="inline"
    />
  );
}
